/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class CallCenterClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    searchCustomer(searchParams: SearchParams | null): Promise<SearchCustomerInformation> {
        let url_ = this.baseUrl + "/api/CallCenter/SearchCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(searchParams);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSearchCustomer(_response);
        });
    }

    protected processSearchCustomer(response: AxiosResponse): Promise<SearchCustomerInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SearchCustomerInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchCustomerInformation>(<any>null);
    }

    getSelectedCustomer(customerNumber: number): Promise<CustomersInformation> {
        let url_ = this.baseUrl + "/api/CallCenter/GetSelectedCustomer/{customerNumber}";
        if (customerNumber === undefined || customerNumber === null)
            throw new Error("The parameter 'customerNumber' must be defined.");
        url_ = url_.replace("{customerNumber}", encodeURIComponent("" + customerNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSelectedCustomer(_response);
        });
    }

    protected processGetSelectedCustomer(response: AxiosResponse): Promise<CustomersInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomersInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomersInformation>(<any>null);
    }

    getSettings(): Promise<SettingsInformation> {
        let url_ = this.baseUrl + "/api/CallCenter/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<SettingsInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SettingsInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingsInformation>(<any>null);
    }

    saveSettings(settings: SettingsInformation | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/CallCenter/SaveSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveSettings(_response);
        });
    }

    protected processSaveSettings(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class HomeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    index(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Home";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    loginGuid(gUID: string | null, appId: string | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/?";
        if (gUID === undefined)
            throw new Error("The parameter 'gUID' must be defined.");
        else
            url_ += "GUID=" + encodeURIComponent("" + gUID) + "&";
        if (appId === undefined)
            throw new Error("The parameter 'appId' must be defined.");
        else
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginGuid(_response);
        });
    }

    protected processLoginGuid(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getVersions(): Promise<Version> {
        let url_ = this.baseUrl + "/api/Home/GetVersions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetVersions(_response);
        });
    }

    protected processGetVersions(response: AxiosResponse): Promise<Version> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Version.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Version>(<any>null);
    }

    getMessage(): Promise<SpecialSituationMessage> {
        let url_ = this.baseUrl + "/api/Home/GetMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMessage(_response);
        });
    }

    protected processGetMessage(response: AxiosResponse): Promise<SpecialSituationMessage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SpecialSituationMessage.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SpecialSituationMessage>(<any>null);
    }
}

export class LoginClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    loginByUserPass(loginCredentials: LoginCredentials | null): Promise<LoginInformation> {
        let url_ = this.baseUrl + "/api/Login/LoginByUserPass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginCredentials);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginByUserPass(_response);
        });
    }

    protected processLoginByUserPass(response: AxiosResponse): Promise<LoginInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginInformation>(<any>null);
    }

    loginByOsaId(guid: string, appId: string | null): Promise<LoginInformation> {
        let url_ = this.baseUrl + "/api/Login/LoginByOsaId/{GUID}?";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        if (appId === undefined)
            throw new Error("The parameter 'appId' must be defined.");
        else
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLoginByOsaId(_response);
        });
    }

    protected processLoginByOsaId(response: AxiosResponse): Promise<LoginInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginInformation>(<any>null);
    }

    logout(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Login/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }
}

export class OsaClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAddressInfo(debtorNumber: number): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osa/GetAddressInfo/{debtorNumber}";
        if (debtorNumber === undefined || debtorNumber === null)
            throw new Error("The parameter 'debtorNumber' must be defined.");
        url_ = url_.replace("{debtorNumber}", encodeURIComponent("" + debtorNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAddressInfo(_response);
        });
    }

    protected processGetAddressInfo(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getLockedOutPageInfo(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osa/GetLockedOutPageInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetLockedOutPageInfo(_response);
        });
    }

    protected processGetLockedOutPageInfo(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getTermsOfUse(user: User | null): Promise<TermsOfUse> {
        let url_ = this.baseUrl + "/api/Osa/GetTermsOfUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTermsOfUse(_response);
        });
    }

    protected processGetTermsOfUse(response: AxiosResponse): Promise<TermsOfUse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TermsOfUse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsOfUse>(<any>null);
    }

    getMaxSizeAttachment(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osa/GetMaxSizeAttachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMaxSizeAttachment(_response);
        });
    }

    protected processGetMaxSizeAttachment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getEditInformation(debtorNumber: string): Promise<EditInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetEditInformation/{debtorNumber}";
        if (debtorNumber === undefined || debtorNumber === null)
            throw new Error("The parameter 'debtorNumber' must be defined.");
        url_ = url_.replace("{debtorNumber}", encodeURIComponent("" + debtorNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetEditInformation(_response);
        });
    }

    protected processGetEditInformation(response: AxiosResponse): Promise<EditInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditInformation>(<any>null);
    }

    addRequest(supportProperties: SupportProperties | null): Promise<AttachmentToCaseParams> {
        let url_ = this.baseUrl + "/api/Osa/AddRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportProperties);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddRequest(_response);
        });
    }

    protected processAddRequest(response: AxiosResponse): Promise<AttachmentToCaseParams> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttachmentToCaseParams.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttachmentToCaseParams>(<any>null);
    }

    addAttachmentToCase(attachmentToCase: AttachmentToCaseParams | null): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Osa/AddAttachmentToCase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachmentToCase);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddAttachmentToCase(_response);
        });
    }

    protected processAddAttachmentToCase(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(<any>null);
    }

    getInstallationDaysAgo(user: User | null): Promise<UserTimeState> {
        let url_ = this.baseUrl + "/api/Osa/GetInstallationDaysAgo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetInstallationDaysAgo(_response);
        });
    }

    protected processGetInstallationDaysAgo(response: AxiosResponse): Promise<UserTimeState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTimeState.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTimeState>(<any>null);
    }

    getAllCloseCases(customer: string): Promise<CaseInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetAllCloseCases/{customer}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllCloseCases(_response);
        });
    }

    protected processGetAllCloseCases(response: AxiosResponse): Promise<CaseInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseInformation>(<any>null);
    }

    getAllGCSCases(): Promise<CaseInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetAllGCSCases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllGCSCases(_response);
        });
    }

    protected processGetAllGCSCases(response: AxiosResponse): Promise<CaseInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseInformation>(<any>null);
    }

    getAllOpenCases(customer: string): Promise<CaseInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetAllOpenCases/{customer}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllOpenCases(_response);
        });
    }

    protected processGetAllOpenCases(response: AxiosResponse): Promise<CaseInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseInformation>(<any>null);
    }

    getAttendanceCase(caseId: string): Promise<AttendanceInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetAttendanceCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAttendanceCase(_response);
        });
    }

    protected processGetAttendanceCase(response: AxiosResponse): Promise<AttendanceInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttendanceInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttendanceInformation>(<any>null);
    }

    getAttendanceGCSCase(caseId: string): Promise<AttendanceInformation> {
        let url_ = this.baseUrl + "/api/Osa/GetAttendanceGCSCase/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAttendanceGCSCase(_response);
        });
    }

    protected processGetAttendanceGCSCase(response: AxiosResponse): Promise<AttendanceInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AttendanceInformation.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AttendanceInformation>(<any>null);
    }

    getCustomerProductLine(debtorNumber: number): Promise<string> {
        let url_ = this.baseUrl + "/api/Osa/GetCustomerProductLine/{debtorNumber}";
        if (debtorNumber === undefined || debtorNumber === null)
            throw new Error("The parameter 'debtorNumber' must be defined.");
        url_ = url_.replace("{debtorNumber}", encodeURIComponent("" + debtorNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            validateStatus: () => true,
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetCustomerProductLine(_response);
        });
    }

    protected processGetCustomerProductLine(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(<any>null);
    }
}

export class SearchCustomerInformation implements ISearchCustomerInformation {
    customers?: Customer[] | undefined;
    totalCustomer!: number;

    constructor(data?: ISearchCustomerInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Customers"])) {
                this.customers = [] as any;
                for (let item of _data["Customers"])
                    this.customers!.push(Customer.fromJS(item));
            }
            this.totalCustomer = _data["TotalCustomer"];
        }
    }

    static fromJS(data: any): SearchCustomerInformation {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCustomerInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["Customers"] = [];
            for (let item of this.customers)
                data["Customers"].push(item.toJSON());
        }
        data["TotalCustomer"] = this.totalCustomer;
        return data; 
    }
}

export interface ISearchCustomerInformation {
    customers?: Customer[] | undefined;
    totalCustomer: number;
}

export class Customer implements ICustomer {
    osaGuid?: string | undefined;
    anspName?: string | undefined;
    anspVorname?: string | undefined;
    anspAdressInfo?: string | undefined;
    adrePlz?: string | undefined;
    adreOrt?: string | undefined;
    adreStrasse?: string | undefined;
    anspZusatztext?: string | undefined;
    adreLand?: string | undefined;
    anspTelPrivat?: string | undefined;
    anspTelGesch?: string | undefined;
    anspTelAlternativ?: string | undefined;
    anspMobil?: string | undefined;
    locked!: boolean;
    updateBerechtigt!: boolean;
    kundengruppe?: string | undefined;
    siteKundennummer?: string | undefined;
    produktlinien?: string | undefined;
    debtorNumber!: number;
    openedCases?: CaseInformation[] | undefined;
    closedCases?: CaseInformation[] | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osaGuid = _data["OsaGuid"];
            this.anspName = _data["AnspName"];
            this.anspVorname = _data["AnspVorname"];
            this.anspAdressInfo = _data["AnspAdressInfo"];
            this.adrePlz = _data["AdrePlz"];
            this.adreOrt = _data["AdreOrt"];
            this.adreStrasse = _data["AdreStrasse"];
            this.anspZusatztext = _data["AnspZusatztext"];
            this.adreLand = _data["AdreLand"];
            this.anspTelPrivat = _data["AnspTelPrivat"];
            this.anspTelGesch = _data["AnspTelGesch"];
            this.anspTelAlternativ = _data["AnspTelAlternativ"];
            this.anspMobil = _data["AnspMobil"];
            this.locked = _data["Locked"];
            this.updateBerechtigt = _data["UpdateBerechtigt"];
            this.kundengruppe = _data["Kundengruppe"];
            this.siteKundennummer = _data["SiteKundennummer"];
            this.produktlinien = _data["Produktlinien"];
            this.debtorNumber = _data["DebtorNumber"];
            if (Array.isArray(_data["OpenedCases"])) {
                this.openedCases = [] as any;
                for (let item of _data["OpenedCases"])
                    this.openedCases!.push(CaseInformation.fromJS(item));
            }
            if (Array.isArray(_data["ClosedCases"])) {
                this.closedCases = [] as any;
                for (let item of _data["ClosedCases"])
                    this.closedCases!.push(CaseInformation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OsaGuid"] = this.osaGuid;
        data["AnspName"] = this.anspName;
        data["AnspVorname"] = this.anspVorname;
        data["AnspAdressInfo"] = this.anspAdressInfo;
        data["AdrePlz"] = this.adrePlz;
        data["AdreOrt"] = this.adreOrt;
        data["AdreStrasse"] = this.adreStrasse;
        data["AnspZusatztext"] = this.anspZusatztext;
        data["AdreLand"] = this.adreLand;
        data["AnspTelPrivat"] = this.anspTelPrivat;
        data["AnspTelGesch"] = this.anspTelGesch;
        data["AnspTelAlternativ"] = this.anspTelAlternativ;
        data["AnspMobil"] = this.anspMobil;
        data["Locked"] = this.locked;
        data["UpdateBerechtigt"] = this.updateBerechtigt;
        data["Kundengruppe"] = this.kundengruppe;
        data["SiteKundennummer"] = this.siteKundennummer;
        data["Produktlinien"] = this.produktlinien;
        data["DebtorNumber"] = this.debtorNumber;
        if (Array.isArray(this.openedCases)) {
            data["OpenedCases"] = [];
            for (let item of this.openedCases)
                data["OpenedCases"].push(item.toJSON());
        }
        if (Array.isArray(this.closedCases)) {
            data["ClosedCases"] = [];
            for (let item of this.closedCases)
                data["ClosedCases"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomer {
    osaGuid?: string | undefined;
    anspName?: string | undefined;
    anspVorname?: string | undefined;
    anspAdressInfo?: string | undefined;
    adrePlz?: string | undefined;
    adreOrt?: string | undefined;
    adreStrasse?: string | undefined;
    anspZusatztext?: string | undefined;
    adreLand?: string | undefined;
    anspTelPrivat?: string | undefined;
    anspTelGesch?: string | undefined;
    anspTelAlternativ?: string | undefined;
    anspMobil?: string | undefined;
    locked: boolean;
    updateBerechtigt: boolean;
    kundengruppe?: string | undefined;
    siteKundennummer?: string | undefined;
    produktlinien?: string | undefined;
    debtorNumber: number;
    openedCases?: CaseInformation[] | undefined;
    closedCases?: CaseInformation[] | undefined;
}

export class CaseInformation implements ICaseInformation {
    caseDescriptionShort?: string | undefined;
    createDate?: Date | undefined;
    caseGroup1?: string | undefined;
    caStClosesCase!: boolean;
    caStDescription?: string | undefined;
    staffSignature?: string | undefined;
    staffShortName?: string | undefined;
    caseInvMarkDescription?: string | undefined;
    caseId!: number;
    recordId!: number;
    caseClosed?: Date | undefined;

    constructor(data?: ICaseInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseDescriptionShort = _data["CaseDescriptionShort"];
            this.createDate = _data["CreateDate"] ? new Date(_data["CreateDate"].toString()) : <any>undefined;
            this.caseGroup1 = _data["CaseGroup1"];
            this.caStClosesCase = _data["CaStClosesCase"];
            this.caStDescription = _data["CaStDescription"];
            this.staffSignature = _data["StaffSignature"];
            this.staffShortName = _data["StaffShortName"];
            this.caseInvMarkDescription = _data["CaseInvMarkDescription"];
            this.caseId = _data["CaseId"];
            this.recordId = _data["RecordId"];
            this.caseClosed = _data["CaseClosed"] ? new Date(_data["CaseClosed"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CaseInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CaseDescriptionShort"] = this.caseDescriptionShort;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["CaseGroup1"] = this.caseGroup1;
        data["CaStClosesCase"] = this.caStClosesCase;
        data["CaStDescription"] = this.caStDescription;
        data["StaffSignature"] = this.staffSignature;
        data["StaffShortName"] = this.staffShortName;
        data["CaseInvMarkDescription"] = this.caseInvMarkDescription;
        data["CaseId"] = this.caseId;
        data["RecordId"] = this.recordId;
        data["CaseClosed"] = this.caseClosed ? this.caseClosed.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICaseInformation {
    caseDescriptionShort?: string | undefined;
    createDate?: Date | undefined;
    caseGroup1?: string | undefined;
    caStClosesCase: boolean;
    caStDescription?: string | undefined;
    staffSignature?: string | undefined;
    staffShortName?: string | undefined;
    caseInvMarkDescription?: string | undefined;
    caseId: number;
    recordId: number;
    caseClosed?: Date | undefined;
}

export class SearchParams implements ISearchParams {
    callcenterDoingSearch?: string | undefined;
    phoneNumber?: string | undefined;
    allowedCountries?: string[] | undefined;
    wordList?: string[] | undefined;
    customerNumber?: string | undefined;
    paginator?: PaginatorProperties | undefined;

    constructor(data?: ISearchParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.callcenterDoingSearch = _data["CallcenterDoingSearch"];
            this.phoneNumber = _data["PhoneNumber"];
            if (Array.isArray(_data["AllowedCountries"])) {
                this.allowedCountries = [] as any;
                for (let item of _data["AllowedCountries"])
                    this.allowedCountries!.push(item);
            }
            if (Array.isArray(_data["WordList"])) {
                this.wordList = [] as any;
                for (let item of _data["WordList"])
                    this.wordList!.push(item);
            }
            this.customerNumber = _data["CustomerNumber"];
            this.paginator = _data["Paginator"] ? PaginatorProperties.fromJS(_data["Paginator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchParams {
        data = typeof data === 'object' ? data : {};
        let result = new SearchParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CallcenterDoingSearch"] = this.callcenterDoingSearch;
        data["PhoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.allowedCountries)) {
            data["AllowedCountries"] = [];
            for (let item of this.allowedCountries)
                data["AllowedCountries"].push(item);
        }
        if (Array.isArray(this.wordList)) {
            data["WordList"] = [];
            for (let item of this.wordList)
                data["WordList"].push(item);
        }
        data["CustomerNumber"] = this.customerNumber;
        data["Paginator"] = this.paginator ? this.paginator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISearchParams {
    callcenterDoingSearch?: string | undefined;
    phoneNumber?: string | undefined;
    allowedCountries?: string[] | undefined;
    wordList?: string[] | undefined;
    customerNumber?: string | undefined;
    paginator?: PaginatorProperties | undefined;
}

export class PaginatorProperties implements IPaginatorProperties {
    currentItems!: number;
    rowsPerPage!: number;
    order!: OrderType;
    sortBy?: string | undefined;

    constructor(data?: IPaginatorProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentItems = _data["CurrentItems"];
            this.rowsPerPage = _data["RowsPerPage"];
            this.order = _data["Order"];
            this.sortBy = _data["SortBy"];
        }
    }

    static fromJS(data: any): PaginatorProperties {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CurrentItems"] = this.currentItems;
        data["RowsPerPage"] = this.rowsPerPage;
        data["Order"] = this.order;
        data["SortBy"] = this.sortBy;
        return data; 
    }
}

export interface IPaginatorProperties {
    currentItems: number;
    rowsPerPage: number;
    order: OrderType;
    sortBy?: string | undefined;
}

export enum OrderType {
    DESC = 0,
    ASC = 1,
}

export class CustomersInformation implements ICustomersInformation {
    customer?: CustomerSelected | undefined;
    coCustomer?: CustomerSelected | undefined;

    constructor(data?: ICustomersInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["Customer"] ? CustomerSelected.fromJS(_data["Customer"]) : <any>undefined;
            this.coCustomer = _data["CoCustomer"] ? CustomerSelected.fromJS(_data["CoCustomer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomersInformation {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["CoCustomer"] = this.coCustomer ? this.coCustomer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomersInformation {
    customer?: CustomerSelected | undefined;
    coCustomer?: CustomerSelected | undefined;
}

export class CustomerSelected implements ICustomerSelected {
    osaGuid?: string | undefined;
    anspName?: string | undefined;
    adrePlz?: string | undefined;
    adreOrt?: string | undefined;
    anspVorname?: string | undefined;
    anspAdressInfo?: string | undefined;
    adreStrasse?: string | undefined;
    locked!: boolean;
    updateBerechtigt!: boolean;
    prepaidSupportHours!: number;
    spentSupportHours!: number;
    kundengruppe?: string | undefined;
    siteKundennummer?: string | undefined;
    produktlinien?: string | undefined;
    debtorNumber!: number;
    openedCases?: CaseInformation[] | undefined;
    closedCases?: CaseInformation[] | undefined;

    constructor(data?: ICustomerSelected) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osaGuid = _data["OsaGuid"];
            this.anspName = _data["AnspName"];
            this.adrePlz = _data["AdrePlz"];
            this.adreOrt = _data["AdreOrt"];
            this.anspVorname = _data["AnspVorname"];
            this.anspAdressInfo = _data["AnspAdressInfo"];
            this.adreStrasse = _data["AdreStrasse"];
            this.locked = _data["Locked"];
            this.updateBerechtigt = _data["UpdateBerechtigt"];
            this.prepaidSupportHours = _data["PrepaidSupportHours"];
            this.spentSupportHours = _data["SpentSupportHours"];
            this.kundengruppe = _data["Kundengruppe"];
            this.siteKundennummer = _data["SiteKundennummer"];
            this.produktlinien = _data["Produktlinien"];
            this.debtorNumber = _data["DebtorNumber"];
            if (Array.isArray(_data["OpenedCases"])) {
                this.openedCases = [] as any;
                for (let item of _data["OpenedCases"])
                    this.openedCases!.push(CaseInformation.fromJS(item));
            }
            if (Array.isArray(_data["ClosedCases"])) {
                this.closedCases = [] as any;
                for (let item of _data["ClosedCases"])
                    this.closedCases!.push(CaseInformation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerSelected {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSelected();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OsaGuid"] = this.osaGuid;
        data["AnspName"] = this.anspName;
        data["AdrePlz"] = this.adrePlz;
        data["AdreOrt"] = this.adreOrt;
        data["AnspVorname"] = this.anspVorname;
        data["AnspAdressInfo"] = this.anspAdressInfo;
        data["AdreStrasse"] = this.adreStrasse;
        data["Locked"] = this.locked;
        data["UpdateBerechtigt"] = this.updateBerechtigt;
        data["PrepaidSupportHours"] = this.prepaidSupportHours;
        data["SpentSupportHours"] = this.spentSupportHours;
        data["Kundengruppe"] = this.kundengruppe;
        data["SiteKundennummer"] = this.siteKundennummer;
        data["Produktlinien"] = this.produktlinien;
        data["DebtorNumber"] = this.debtorNumber;
        if (Array.isArray(this.openedCases)) {
            data["OpenedCases"] = [];
            for (let item of this.openedCases)
                data["OpenedCases"].push(item.toJSON());
        }
        if (Array.isArray(this.closedCases)) {
            data["ClosedCases"] = [];
            for (let item of this.closedCases)
                data["ClosedCases"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerSelected {
    osaGuid?: string | undefined;
    anspName?: string | undefined;
    adrePlz?: string | undefined;
    adreOrt?: string | undefined;
    anspVorname?: string | undefined;
    anspAdressInfo?: string | undefined;
    adreStrasse?: string | undefined;
    locked: boolean;
    updateBerechtigt: boolean;
    prepaidSupportHours: number;
    spentSupportHours: number;
    kundengruppe?: string | undefined;
    siteKundennummer?: string | undefined;
    produktlinien?: string | undefined;
    debtorNumber: number;
    openedCases?: CaseInformation[] | undefined;
    closedCases?: CaseInformation[] | undefined;
}

export class SettingsInformation implements ISettingsInformation {
    termsOfUse?: string | undefined;
    blockedAccount?: string | undefined;
    maxSizeAttachment!: number;
    specialSituationMessage?: SpecialSituationMessage | undefined;

    constructor(data?: ISettingsInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termsOfUse = _data["TermsOfUse"];
            this.blockedAccount = _data["BlockedAccount"];
            this.maxSizeAttachment = _data["MaxSizeAttachment"];
            this.specialSituationMessage = _data["SpecialSituationMessage"] ? SpecialSituationMessage.fromJS(_data["SpecialSituationMessage"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SettingsInformation {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TermsOfUse"] = this.termsOfUse;
        data["BlockedAccount"] = this.blockedAccount;
        data["MaxSizeAttachment"] = this.maxSizeAttachment;
        data["SpecialSituationMessage"] = this.specialSituationMessage ? this.specialSituationMessage.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISettingsInformation {
    termsOfUse?: string | undefined;
    blockedAccount?: string | undefined;
    maxSizeAttachment: number;
    specialSituationMessage?: SpecialSituationMessage | undefined;
}

export class SpecialSituationMessage implements ISpecialSituationMessage {
    dateFrom!: Date;
    dateTo!: Date;
    message?: string | undefined;

    constructor(data?: ISpecialSituationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFrom = _data["DateFrom"] ? new Date(_data["DateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["DateTo"] ? new Date(_data["DateTo"].toString()) : <any>undefined;
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): SpecialSituationMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialSituationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["DateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["Message"] = this.message;
        return data; 
    }
}

export interface ISpecialSituationMessage {
    dateFrom: Date;
    dateTo: Date;
    message?: string | undefined;
}

export class Version implements IVersion {
    versionCA?: string | undefined;
    versionCSS?: string | undefined;

    constructor(data?: IVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionCA = _data["versionCA"];
            this.versionCSS = _data["versionCSS"];
        }
    }

    static fromJS(data: any): Version {
        data = typeof data === 'object' ? data : {};
        let result = new Version();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionCA"] = this.versionCA;
        data["versionCSS"] = this.versionCSS;
        return data; 
    }
}

export interface IVersion {
    versionCA?: string | undefined;
    versionCSS?: string | undefined;
}

export class LoginInformation implements ILoginInformation {
    token?: string | undefined;
    loginResultState!: LoginStatesOptions;
    url?: string | undefined;

    constructor(data?: ILoginInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.loginResultState = _data["LoginResultState"];
            this.url = _data["Url"];
        }
    }

    static fromJS(data: any): LoginInformation {
        data = typeof data === 'object' ? data : {};
        let result = new LoginInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["LoginResultState"] = this.loginResultState;
        data["Url"] = this.url;
        return data; 
    }
}

export interface ILoginInformation {
    token?: string | undefined;
    loginResultState: LoginStatesOptions;
    url?: string | undefined;
}

export enum LoginStatesOptions {
    Success = 0,
    FailedlUserPass = 1,
    OsaIdMissing = 2,
    CloudServiceException = 3,
    InvalidUsername = 4,
    Locked = 5,
    NotAuthorized = 6,
    UnexpectedError = 7,
}

export class LoginCredentials implements ILoginCredentials {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): LoginCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        return data; 
    }
}

export interface ILoginCredentials {
    username?: string | undefined;
    password?: string | undefined;
}

export class TermsOfUse implements ITermsOfUse {
    singlePage!: boolean;
    prepaidSupportHours!: number;
    spentSupportHours!: number;
    text?: string | undefined;

    constructor(data?: ITermsOfUse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singlePage = _data["SinglePage"];
            this.prepaidSupportHours = _data["PrepaidSupportHours"];
            this.spentSupportHours = _data["SpentSupportHours"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): TermsOfUse {
        data = typeof data === 'object' ? data : {};
        let result = new TermsOfUse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SinglePage"] = this.singlePage;
        data["PrepaidSupportHours"] = this.prepaidSupportHours;
        data["SpentSupportHours"] = this.spentSupportHours;
        data["Text"] = this.text;
        return data; 
    }
}

export interface ITermsOfUse {
    singlePage: boolean;
    prepaidSupportHours: number;
    spentSupportHours: number;
    text?: string | undefined;
}

export class User implements IUser {
    osaId?: string | undefined;
    appId!: number;
    customer?: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osaId = _data["OsaId"];
            this.appId = _data["AppId"];
            this.customer = _data["Customer"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OsaId"] = this.osaId;
        data["AppId"] = this.appId;
        data["Customer"] = this.customer;
        return data; 
    }
}

export interface IUser {
    osaId?: string | undefined;
    appId: number;
    customer?: string | undefined;
}

export class EditInformation implements IEditInformation {
    anspName?: string | undefined;
    anspZusatztext?: string | undefined;
    anspTelAlternativ?: string | undefined;
    anspTelGesch?: string | undefined;
    adreOrt?: string | undefined;
    adrePlz?: string | undefined;
    adreLand?: string | undefined;
    adreStrasse?: string | undefined;
    adreWebside?: string | undefined;
    anspeMail?: string | undefined;
    anspFax?: string | undefined;

    constructor(data?: IEditInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anspName = _data["AnspName"];
            this.anspZusatztext = _data["AnspZusatztext"];
            this.anspTelAlternativ = _data["AnspTelAlternativ"];
            this.anspTelGesch = _data["AnspTelGesch"];
            this.adreOrt = _data["AdreOrt"];
            this.adrePlz = _data["AdrePlz"];
            this.adreLand = _data["AdreLand"];
            this.adreStrasse = _data["AdreStrasse"];
            this.adreWebside = _data["AdreWebside"];
            this.anspeMail = _data["AnspeMail"];
            this.anspFax = _data["AnspFax"];
        }
    }

    static fromJS(data: any): EditInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EditInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AnspName"] = this.anspName;
        data["AnspZusatztext"] = this.anspZusatztext;
        data["AnspTelAlternativ"] = this.anspTelAlternativ;
        data["AnspTelGesch"] = this.anspTelGesch;
        data["AdreOrt"] = this.adreOrt;
        data["AdrePlz"] = this.adrePlz;
        data["AdreLand"] = this.adreLand;
        data["AdreStrasse"] = this.adreStrasse;
        data["AdreWebside"] = this.adreWebside;
        data["AnspeMail"] = this.anspeMail;
        data["AnspFax"] = this.anspFax;
        return data; 
    }
}

export interface IEditInformation {
    anspName?: string | undefined;
    anspZusatztext?: string | undefined;
    anspTelAlternativ?: string | undefined;
    anspTelGesch?: string | undefined;
    adreOrt?: string | undefined;
    adrePlz?: string | undefined;
    adreLand?: string | undefined;
    adreStrasse?: string | undefined;
    adreWebside?: string | undefined;
    anspeMail?: string | undefined;
    anspFax?: string | undefined;
}

export class AttachmentToCaseParams implements IAttachmentToCaseParams {
    file?: string | undefined;
    filename?: string | undefined;
    companyId!: number;
    caseRecordId!: number;
    debtorNumber!: number;
    contactId!: number;

    constructor(data?: IAttachmentToCaseParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["File"];
            this.filename = _data["Filename"];
            this.companyId = _data["CompanyId"];
            this.caseRecordId = _data["CaseRecordId"];
            this.debtorNumber = _data["DebtorNumber"];
            this.contactId = _data["ContactId"];
        }
    }

    static fromJS(data: any): AttachmentToCaseParams {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentToCaseParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["File"] = this.file;
        data["Filename"] = this.filename;
        data["CompanyId"] = this.companyId;
        data["CaseRecordId"] = this.caseRecordId;
        data["DebtorNumber"] = this.debtorNumber;
        data["ContactId"] = this.contactId;
        return data; 
    }
}

export interface IAttachmentToCaseParams {
    file?: string | undefined;
    filename?: string | undefined;
    companyId: number;
    caseRecordId: number;
    debtorNumber: number;
    contactId: number;
}

export class SupportProperties implements ISupportProperties {
    osaId?: string | undefined;
    debtorNumber?: string | undefined;
    appId!: number;
    callCenterId?: string | undefined;
    contactPerson?: string | undefined;
    productLine?: string | undefined;
    product?: string | undefined;
    attachments?: Attachment[] | undefined;
    caseCallBackNotBefore?: Date | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    supportType!: SupportType;

    constructor(data?: ISupportProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.osaId = _data["OsaId"];
            this.debtorNumber = _data["DebtorNumber"];
            this.appId = _data["AppId"];
            this.callCenterId = _data["CallCenterId"];
            this.contactPerson = _data["ContactPerson"];
            this.productLine = _data["ProductLine"];
            this.product = _data["Product"];
            if (Array.isArray(_data["Attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["Attachments"])
                    this.attachments!.push(Attachment.fromJS(item));
            }
            this.caseCallBackNotBefore = _data["CaseCallBackNotBefore"] ? new Date(_data["CaseCallBackNotBefore"].toString()) : <any>undefined;
            this.subject = _data["Subject"];
            this.message = _data["Message"];
            this.supportType = _data["SupportType"];
        }
    }

    static fromJS(data: any): SupportProperties {
        data = typeof data === 'object' ? data : {};
        let result = new SupportProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["OsaId"] = this.osaId;
        data["DebtorNumber"] = this.debtorNumber;
        data["AppId"] = this.appId;
        data["CallCenterId"] = this.callCenterId;
        data["ContactPerson"] = this.contactPerson;
        data["ProductLine"] = this.productLine;
        data["Product"] = this.product;
        if (Array.isArray(this.attachments)) {
            data["Attachments"] = [];
            for (let item of this.attachments)
                data["Attachments"].push(item.toJSON());
        }
        data["CaseCallBackNotBefore"] = this.caseCallBackNotBefore ? this.caseCallBackNotBefore.toISOString() : <any>undefined;
        data["Subject"] = this.subject;
        data["Message"] = this.message;
        data["SupportType"] = this.supportType;
        return data; 
    }
}

export interface ISupportProperties {
    osaId?: string | undefined;
    debtorNumber?: string | undefined;
    appId: number;
    callCenterId?: string | undefined;
    contactPerson?: string | undefined;
    productLine?: string | undefined;
    product?: string | undefined;
    attachments?: Attachment[] | undefined;
    caseCallBackNotBefore?: Date | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    supportType: SupportType;
}

export class Attachment implements IAttachment {
    file?: string | undefined;
    filename?: string | undefined;
    size?: string | undefined;

    constructor(data?: IAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["File"];
            this.filename = _data["Filename"];
            this.size = _data["Size"];
        }
    }

    static fromJS(data: any): Attachment {
        data = typeof data === 'object' ? data : {};
        let result = new Attachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["File"] = this.file;
        data["Filename"] = this.filename;
        data["Size"] = this.size;
        return data; 
    }
}

export interface IAttachment {
    file?: string | undefined;
    filename?: string | undefined;
    size?: string | undefined;
}

export enum SupportType {
    Standard = 0,
    PrioCall = 1,
    GCS = 2,
}

export class UserTimeState implements IUserTimeState {
    daysFromInstallationDate!: number;
    supportTimeCredit!: boolean;

    constructor(data?: IUserTimeState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daysFromInstallationDate = _data["DaysFromInstallationDate"];
            this.supportTimeCredit = _data["SupportTimeCredit"];
        }
    }

    static fromJS(data: any): UserTimeState {
        data = typeof data === 'object' ? data : {};
        let result = new UserTimeState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DaysFromInstallationDate"] = this.daysFromInstallationDate;
        data["SupportTimeCredit"] = this.supportTimeCredit;
        return data; 
    }
}

export interface IUserTimeState {
    daysFromInstallationDate: number;
    supportTimeCredit: boolean;
}

export class AttendanceInformation implements IAttendanceInformation {
    staffSignature?: string | undefined;
    caTcDescription?: string | undefined;
    caTcStart?: Date | undefined;
    caTcEnd?: Date | undefined;
    caTcHours?: number | undefined;
    caTcHoursFree?: number | undefined;

    constructor(data?: IAttendanceInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffSignature = _data["StaffSignature"];
            this.caTcDescription = _data["CaTcDescription"];
            this.caTcStart = _data["CaTcStart"] ? new Date(_data["CaTcStart"].toString()) : <any>undefined;
            this.caTcEnd = _data["CaTcEnd"] ? new Date(_data["CaTcEnd"].toString()) : <any>undefined;
            this.caTcHours = _data["CaTcHours"];
            this.caTcHoursFree = _data["CaTcHoursFree"];
        }
    }

    static fromJS(data: any): AttendanceInformation {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StaffSignature"] = this.staffSignature;
        data["CaTcDescription"] = this.caTcDescription;
        data["CaTcStart"] = this.caTcStart ? this.caTcStart.toISOString() : <any>undefined;
        data["CaTcEnd"] = this.caTcEnd ? this.caTcEnd.toISOString() : <any>undefined;
        data["CaTcHours"] = this.caTcHours;
        data["CaTcHoursFree"] = this.caTcHoursFree;
        return data; 
    }
}

export interface IAttendanceInformation {
    staffSignature?: string | undefined;
    caTcDescription?: string | undefined;
    caTcStart?: Date | undefined;
    caTcEnd?: Date | undefined;
    caTcHours?: number | undefined;
    caTcHoursFree?: number | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}